import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import HeaderSearchPopover from "../components/algolia/HeaderSearchPopover.jsx";

export default class HeaderSearchPopoverModule extends BaseModule {
  init() {
    // Only mount on large screens and above to match design intent
    this.mq = window.matchMedia("(min-width: 1024px)");
    this.handleMedia = this.handleMedia.bind(this);
    this.handleMedia(this.mq);
    this.mq.addEventListener("change", this.handleMedia);
  }

  handleMedia(e) {
    if (e.matches) {
      this.mountReact();
    } else {
      this.unmountReact();
    }
  }

  mountReact() {
    if (this.reactRoot) return;
    this.reactRoot = createRoot(this.el);
    this.reactRoot.render(createElement(HeaderSearchPopover));
  }

  unmountReact() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }
  }

  destroy() {
    if (this.mq) {
      this.mq.removeEventListener("change", this.handleMedia);
    }
    this.unmountReact();
  }
}
